import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';

import SideOption from 'src/components/ui/SideOption';
import SideContact from 'src/components/ui/SideContact';
import SideEntry from 'src/components/ui/SideEntry';

const SideItems = ({
	options = [],
	contacts = [],
	calls = [],
	objections = [],
	files = [],
}) => (
	<>
		{Boolean(options.length) && (
			<Stack spacing={0.5}>
				{options.map((option) => (
					<SideOption {...option} key={option.id} />
				))}
			</Stack>
		)}

		{Boolean(contacts.length) && (
			<Stack spacing={2}>
				{contacts.map((contact) => (
					<SideContact {...contact} key={contact.id} />
				))}
			</Stack>
		)}

		{Boolean(calls.length) && (
			<Stack spacing={2}>
				{calls.map((call) => (
					<SideOption {...call} key={call.id} />
				))}
			</Stack>
		)}

		{Boolean(objections.length) && (
			<Stack spacing={2}>
				{objections.map((objection) => (
					<SideEntry {...objection} key={objection.id} />
				))}
			</Stack>
		)}

		{Boolean(files.length) && (
			<Stack spacing={2}>
				{files.map((file) => (
					<SideEntry {...file} key={file.id} />
				))}
			</Stack>
		)}
	</>
);

SideItems.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape(SideOption.propTypes)),
	contacts: PropTypes.arrayOf(PropTypes.shape(SideContact.propTypes)),
	calls: PropTypes.arrayOf(PropTypes.shape(SideOption.propTypes)),
	objections: PropTypes.arrayOf(PropTypes.shape(SideEntry.propTypes)),
	files: PropTypes.arrayOf(PropTypes.shape(SideEntry.propTypes)),
};

export default SideItems;
